/**
 * 커서 방향
 * 참고(API) : https://github.kakaocorp.com/kakaopage/api/blob/70e2cadd99caff4844d3a89525d57448d8d62d74/common/src/main/java/com/kakaopage/common/model/enums/CursorDirection.java#L3
 */
export enum CursorDirectionVo {
  PREV = 'PREV',
  NEXT = 'NEXT',
  INIT = 'INIT',
  // product/list의 init과 같은 값으로 보던 회차를 기준으로 회차를 불러옵니다.
  ANCHOR = 'ANCHOR',
}
